import React, { FC } from "react";
import { Link, LinkProps } from "react-router-dom";

type AppLinkProps = {
  highlighted?: boolean;
};

const AppLink: FC<LinkProps & AppLinkProps> = ({ children, highlighted, ...rest }) => {
  return (
    <Link
      {...rest}
      style={{
        fontSize: 16,
        color: highlighted ? "#FF7262" : "#000",
        fontWeight: highlighted ? 600 : 500,
        lineHeight: "19px",
        textDecoration: "none",
        letterSpacing: "1.25px",
        ...(rest.style ?? {}),
      }}
    >
      {children}
    </Link>
  );
};

export default AppLink;
